import {
  CREATE_EMAIL_DOMAIN_REQUEST,
  CREATE_EMAIL_DOMAIN_SUCCEEDED,
  CREATE_EMAIL_DOMAIN_FAILED,
  CREATE_EMAIL_DOMAIN_CANCELLED,
  FETCH_EMAIL_DOMAINS_REQUEST,
  FETCH_EMAIL_DOMAINS_SUCCEEDED,
  FETCH_EMAIL_DOMAINS_FAILED,
  FETCH_EMAIL_DOMAIN_USERS_COUNT_SUCCEEDED,
  FETCH_EMAIL_DOMAIN_USERS_COUNT_FAILED,
  REMOVE_EMAIL_DOMAIN_REQUEST,
  REMOVE_EMAIL_DOMAIN_SUCCEEDED,
  REMOVE_EMAIL_DOMAIN_FAILED
} from '../actions/emailDomainActions'

const initialState = {
  ids: [],
  isLoading: false
}

export default function emailDomains(state = initialState, action) {
  switch (action.type) {
    case CREATE_EMAIL_DOMAIN_REQUEST:
      return { ...state, isLoading: true }
    case CREATE_EMAIL_DOMAIN_SUCCEEDED:
      return {
        ...state,
        isLoading: false,
        ids: [...state.ids, action.response.result]
      }
    case FETCH_EMAIL_DOMAINS_REQUEST:
      return { ...state, isLoading: true, ids: [] }
    case FETCH_EMAIL_DOMAINS_SUCCEEDED:
      return { ...state, isLoading: false, ids: action.response.result }
    case REMOVE_EMAIL_DOMAIN_REQUEST:
      return { ...state, isLoading: true }
    case REMOVE_EMAIL_DOMAIN_SUCCEEDED:
      const idx = state.ids.indexOf(action.emailDomain.id)
      return {
        ...state,
        isLoading: false,
        ids: [...state.ids.slice(0, idx), ...state.ids.slice(idx + 1)]
      }
    case FETCH_EMAIL_DOMAIN_USERS_COUNT_SUCCEEDED:
    case CREATE_EMAIL_DOMAIN_FAILED:
    case CREATE_EMAIL_DOMAIN_CANCELLED:
    case FETCH_EMAIL_DOMAIN_USERS_COUNT_FAILED:
    case FETCH_EMAIL_DOMAINS_FAILED:
    case REMOVE_EMAIL_DOMAIN_FAILED:
      return { ...state, isLoading: false }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ../src/reducers/emailDomains.js